import type { FC, ReactNode } from 'react'

import { Footer } from '@/components/Footer/Footer'
import { Logo } from '@/components/Logo/Logo'
import { RadarMenu } from '@/components/RadarMenu/RadarMenu'
import { cn } from '@/lib/utils'
import styles from './Layout.module.css'

export type LayoutClass = 'default' | 'full'

interface LayoutProps {
  children: ReactNode
  layoutClass?: LayoutClass
  hideFooter?: boolean
}

export const Layout: FC<LayoutProps> = ({
  children,
  layoutClass = 'default',
  hideFooter = false
}) => {
  return (
    <div
      id="layout"
      className={cn(styles.layout, styles[layoutClass], 'p-6')}
      data-testid="layout-container"
    >
      <header
        className={cn(styles.container, styles.header)}
        data-testid="layout-header"
      >
        <Logo />
        <RadarMenu />
      </header>
      <main className={cn(styles.content)} data-testid="layout-content">
        {children}
      </main>
      {!hideFooter && (
        <footer
          className={cn(styles.container, styles.footer)}
          data-testid="layout-footer"
        >
          <Footer />
        </footer>
      )}
    </div>
  )
}
